import PropTypes from "prop-types";
import Text from "../text/Text";
import {
  getCampaignAudienceDetailItems,
  getCampaignAudienceTypeLabel,
  inferCampaignTargetAudience,
} from "../../config/utilities/campaignAudienceAudit";

const NUMBERED_AUDIENCE_TYPES = new Set([
  "family",
  "stop",
  "tripType",
  "schedule",
]);

const formatItemTitle = (audienceType, item, index) => {
  if (!NUMBERED_AUDIENCE_TYPES.has(audienceType)) return item.title;
  return `${index + 1}. ${item.title}`;
};

const renderStudentNames = (students) => {
  if (!Array.isArray(students) || students.length === 0) return null;

  return (
    <ol className="audit-log-campaign-audience__students">
      {students.map((name, index) => (
        <li
          key={`${name}-${index}`}
          className="audit-log-campaign-audience__student"
        >
          <Text size="0.75rem" color="#667085" weight="400" text={name} />
        </li>
      ))}
    </ol>
  );
};

export default function CampaignAudienceAuditDisplay({ record }) {
  if (!record) return null;

  const audienceType = inferCampaignTargetAudience(record);
  const typeLabel = getCampaignAudienceTypeLabel(record);
  const items = getCampaignAudienceDetailItems(record);

  if (audienceType === "campus" && items.length > 0) {
    const campusNames = items.map((item) => item.title).filter(Boolean);
    return (
      <div className="audit-log-campaign-audience audit-log-campaign-audience--campus">
        <span className="audit-log-campaign-audience__label">Campus:</span>
        <span className="audit-log-campaign-audience__value">
          {campusNames.join(", ")}
        </span>
      </div>
    );
  }

  if (items.length === 0) {
    return <Text size="0.875rem" color="#101828" weight="500" text={typeLabel} />;
  }

  const showTypeHeading = items.length > 1 || items[0]?.title !== typeLabel;

  return (
    <div className="audit-log-campaign-audience">
      {showTypeHeading ? (
        <Text size="0.875rem" color="#101828" weight="600" text={typeLabel} />
      ) : null}
      <div className="audit-log-campaign-audience__items">
        {items.map((item, index) => (
          <div
            key={`${item.title}-${index}`}
            className="audit-log-schedule-item audit-log-campaign-audience__item"
          >
            <Text
              size="0.875rem"
              color="#101828"
              weight="500"
              text={formatItemTitle(audienceType, item, index)}
            />
            {item.students?.length ? (
              renderStudentNames(item.students)
            ) : item.subtitle ? (
              <Text
                size="0.75rem"
                color="#667085"
                weight="400"
                text={item.subtitle}
              />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}

CampaignAudienceAuditDisplay.propTypes = {
  record: PropTypes.object,
};
